import { ChangeEvent, useState } from "react";
import { Button, Checkbox, Colors } from "@blueprintjs/core";
import { styled } from "styled-components";
import { Box, CustomCard } from "ui-components";
import useSession from "ui-io/use-session";
import InputField from "../input-field";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const { isAuthenticated, login } = useSession();
  const navigate = useNavigate();
  const [userDetail, setUserDetail] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
  });


  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    const userObj: any = { ...userDetail };
    if (name && value) userObj[name] = value;
    setUserDetail({ ...userObj });
  };

  const onSubmitSignUp = () => {
    if (userDetail.email === "rahul" && userDetail.password === "0000") {
      if (login) {
        login({
          token: "qwqwq",
          userId: "1234",
          username: "rahul",
          isAuthenticated: true,
        });
      }
    }
  };
 
  return (
    <Box flexDir="row" justify="between" pt={"xlarge"}  mt={"medium"} items="center">
      <Box mt={"large"}>
        <BannerContent> The startup discovery engine</BannerContent>
        <BannerContent isDark={true}> Find your fund returners</BannerContent>
        <img
          src="/images/login-banner.svg"
          alt="Login Banner"
          className="mt-xxlg"
        />
      </Box>
        <CustomCard maxWidth="400px">
          <div className="pt-xxlg pb-xxlg pl-md pr-md">
            <div className="fs-26 fw-bold">Create Account</div>
            <div className="mt-md fs-13">
              Set up your email and password to create account!
            </div>

            <InputField
              label={"Full Name"}
              name={"fullName"}
              type={"text"}
              placeholder="Enter your full name"
              onChange={handleOnChange}
              value={userDetail?.fullName ?? ""}
            />
            <InputField
              label={"Email"}
              name={"email"}
              type={"text"}
              placeholder="mail@simple.com"
              onChange={handleOnChange}
              value={userDetail?.email ?? ""}
            />

            <InputField
              label={"Phone Number"}
              name={"phoneNumber"}
              type={"text"}
              placeholder="Enter your phone number"
              onChange={handleOnChange}
              value={userDetail?.phoneNumber ?? ""}
            />
            <InputField
              label={"Passworrd"}
              name={"password"}
              type={"password"}
              placeholder="Min. 8 characters"
              onChange={handleOnChange}
              value={userDetail?.password ?? ""}
            />
            <InputField
              label={"Confirm Passworrd"}
              name={"confirmPassword"}
              type={"password"}
              placeholder="Min. 8 characters"
              onChange={handleOnChange}
              value={userDetail?.confirmPassword ?? ""}
            />

            <div className="mt-lg fs-12"> <Checkbox checked={true} label="Keep me logged in" onChange={()=>{} } /></div>
            <Button className="w-100 mt-xs" onClick={onSubmitSignUp}>
              Create Account
            </Button>

            <div className={"mt-sm fs-13"}>
              <span>Click here to </span>
              <a
                className={"classes.haveAccountLogin"}
                onClick={() => {
                  navigate("/sign-in");
                }}
              >
                Sign in to your existing account
              </a>
            </div>
          </div>
        </CustomCard>
    </Box>
  );
};
export default SignUp;

const BannerContent = styled.div<{ isDark?: boolean }>`
  font-size: 30px;
  font-weight: 600;
  line-height: 1.3em;
  color: ${({ isDark, theme: { darkMode } }) =>
    isDark
      ? darkMode
        ? Colors.LIGHT_GRAY5
        : Colors.BLACK
      : darkMode
        ? Colors.LIGHT_GRAY1
        : Colors.GRAY3};
`;

// const SignUpContainer = styled.div`
//   float: right;
//   margin-top: 3%;
//   margin-right: -40px;
// `;
